var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cssClassMap } from '../../../constants/SportCssMap';
import { matchStartDateSortFunc } from '../../../rendering-commons/Sorting';
import Match from '../common/sportsGrid/HighlightedLiveMatch';
import { winWithoutDraw } from '../common/sportsGrid/matchType';
import { defineMessages, injectIntl } from 'react-intl';
var messages = defineMessages({
    grid_w1: {
        id: 'grid.w1',
        defaultMessage: 'П1'
    },
    grid_x: {
        id: 'grid.x',
        defaultMessage: 'X'
    },
    grid_w2: {
        id: 'grid.w2',
        defaultMessage: 'П2'
    },
});
var League = /** @class */ (function (_super) {
    __extends(League, _super);
    function League() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    League.prototype.render = function () {
        var _a = this.props, sportName = _a.sportName, league = _a.league, matches = _a.matches, section = _a.section, languageId = _a.languageId, gridLocalization = _a.gridLocalization, intl = _a.intl, showSport = _a.showSport;
        var leagueMatchesIds = league.get('matches');
        var sportId = league.get('sportId');
        var leagueMatches = leagueMatchesIds.map(function (m) { return matches.get(m); });
        var sportCssClass = "".concat(cssClassMap[league.get('sportId')]);
        var props = {
            languageId: languageId,
            section: section,
            gridLocalization: gridLocalization,
            sportCssClass: sportCssClass
        };
        var renderMatchesGroup = [];
        leagueMatches.sort(matchStartDateSortFunc).map(function (match) {
            renderMatchesGroup.push(_jsx(Match, __assign({ id: match.get('id') }, props), match.get('id')));
        });
        var cls = winWithoutDraw.find(function (m) { return m === sportId; }) ? ' win-without-draw' : '';
        return (_jsxs("div", __assign({ className: 'section' }, { children: [_jsxs("div", __assign({ className: "title ".concat(sportCssClass, " ").concat(cls) }, { children: [_jsxs("div", __assign({ className: 'title__name' }, { children: [showSport && sportName, " ", league.get('name')] })), _jsxs("div", __assign({ className: 'title__rates' }, { children: [_jsx("div", __assign({ className: 'title__rate' }, { children: intl.formatMessage(messages.grid_w1) })), !winWithoutDraw.find(function (m) { return m === sportId; }) && _jsx("div", __assign({ className: 'title__rate' }, { children: intl.formatMessage(messages.grid_x) })), _jsx("div", __assign({ className: 'title__rate' }, { children: intl.formatMessage(messages.grid_w2) }))] }))] })), _jsx("div", __assign({ className: 'items' }, { children: renderMatchesGroup }))] })));
    };
    League.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        expandedLeague: PropTypes.bool,
        showSport: PropTypes.bool,
        league: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        matches: PropTypes.object.isRequired,
        languageId: PropTypes.number.isRequired,
        sportName: PropTypes.string.isRequired,
    };
    return League;
}(React.Component));
function mapStateToProps(state, props) {
    var id = props.id, section = props.section;
    var league = state.application.getIn([section, 'leagues', id]);
    var matches = state.application.getIn([section, 'matches']);
    var languageId = state.application.get('languageId');
    return {
        league: league,
        matches: matches,
        languageId: languageId
    };
}
League = connect(mapStateToProps)(League);
export default injectIntl(League);



// WEBPACK FOOTER //
// ./src/components/grid/live/League.jsx